import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'services/config';
import { Pagination } from '@/models';
import { buildQueryString, prepareHeaders } from '@/state/slices/index.ts';
import { IUser } from '@/models/auth.ts';
import { PhysicianOption, UserParams } from '@/models/user.ts';

export const UserAPI = createApi({
  reducerPath: 'UserAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders,
  }),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getUsers: builder.query<Pagination<IUser>, UserParams>({
      query: (filters) => {
        const queryString = buildQueryString(filters as Record<string, string>);
        return {
          url: `/users/${queryString}`,
          method: 'GET',
        };
      },
      providesTags: (result) =>
        result
          ? [
              { type: 'User', id: 'LIST' },
              ...result.results.map((a) => ({
                type: 'User' as const,
                id: a.id,
              })),
            ]
          : [{ type: 'User', id: 'LIST' }],
    }),
    getPhysicianOptions: builder.query<Pagination<PhysicianOption>, void>({
      query: () => ({
        url: `/users/?roles=PHYSICIAN&roles=TECHNICIAN&paginate=false`,
        method: 'GET',
      }),
      providesTags: [{ type: 'User', id: 'LIST' }],
    }),
    changePassword: builder.mutation<
      { detail?: string },
      { currentPassword: string; newPassword: string }
    >({
      query: (body) => ({
        url: `/auth/change-password/`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useGetPhysicianOptionsQuery,
  useChangePasswordMutation,
} = UserAPI;
